<template>
  <div class="app-down"></div>
</template>
<script>
import { isIphone } from "../utils/utils";
import { siteMixin } from "../utils/mixin";
export default {
  mixins: [siteMixin],
  mounted() {
    this.down();
  },
  methods: {
    down() {
      const {
        androidQrlogo,
        iosQrlogo,
        appDownAndroid,
        appDownApple,
        domainHttp,
        mdomain,
        agencyId,
      } = this.siteConfig;

      const qrlogo = isIphone() ? iosQrlogo : androidQrlogo;
      const customUrl = isIphone() ? appDownApple : appDownAndroid;
      // 根据设备类型生成下载链接
      const downLoadUrl = this.generateDownloadUrl(
        isIphone(),
        qrlogo,
        customUrl,
        domainHttp,
        mdomain
      );
      
      if (!downLoadUrl) return this.$message.info("无下载链接");
    
      const idString = downLoadUrl.split('/')
      
      const hasAagencyId = idString?.[idString.length - 1]
      
      let finalUrl = downLoadUrl
      if (!Number(hasAagencyId)) {
        finalUrl = `${finalUrl}?agencyId=${agencyId}`
      }
     
      window.location.href = finalUrl;
    },
    // 定义一个函数来处理下载链接的生成
    generateDownloadUrl(isIphone, qrlogo, customUrl, domainHttp, mdomain) {
      const systemDownLoadUrl = `/special/${isIphone ? "ios" : "apk"}/index`;
      return qrlogo
        ? `${
            domainHttp || window.location.protocol
          }://${mdomain}${systemDownLoadUrl}`
        : customUrl;
    },
  },
};
</script>
<style scoped>
.app-down {
  width: 100vw;
  height: 100vh;
  background-color: #fff;
  z-index: 999;
}
</style>
